import { Types } from '../../../constants';
import { IsHelper } from '../IsHelper';
export class IsObjectHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Object;
    }
}

//# sourceMappingURL=IsObjectHelper.js.map
